import {
  addAndTrack,
  incElementalBnes,
  simpleAnTmaker
} from "../../../calculators/helpers";
import { applyPct, getFinalTlLv, round1, round2 } from "../../../helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { lightPAs_Bow } from "../config";
import { checkAscs, checkCons, xtraTlLv } from "../helpers";
import tlLvMults from "../tlLvMults";

const windGiftBnValue = ({ toSelf, inputs, char, partyData }) => {
  const level = toSelf
    ? getFinalTlLv(char, Faruzan.actvTalents[2], partyData)
    : inputs?.[0] || 0;
  return level ? round1(18 * tlLvMults[2][level]) : 0;
};

const Faruzan = {
  code: 64,
  name: "Faruzan",
  icon: "b/b2/Faruzan_Icon",
  sideIcon: "0/00/Character_Faruzan_Side_Icon",
  rarity: 4,
  nation: "Sumeru",
  vision: "Anemo",
  weapon: "Bow",
  stats: [
    { "Base HP": 802, "Base ATK": 16, "Base DEF": 53 },
    { "Base HP": 2061, "Base ATK": 42, "Base DEF": 135 },
    { "Base HP": 2661, "Base ATK": 55, "Base DEF": 175 },
    { "Base HP": 3985, "Base ATK": 82, "Base DEF": 262 },
    { "Base HP": 4411, "Base ATK": 91, "Base DEF": 289, "ATK%": 6 },
    { "Base HP": 5074, "Base ATK": 104, "Base DEF": 333, "ATK%": 6 },
    { "Base HP": 5642, "Base ATK": 116, "Base DEF": 370, "ATK%": 12 },
    { "Base HP": 6305, "Base ATK": 129, "Base DEF": 414, "ATK%": 12 },
    { "Base HP": 6731, "Base ATK": 138, "Base DEF": 442, "ATK%": 12 },
    { "Base HP": 7393, "Base ATK": 152, "Base DEF": 485, "ATK%": 12 },
    { "Base HP": 7819, "Base ATK": 161, "Base DEF": 513, "ATK%": 18 },
    { "Base HP": 8481, "Base ATK": 174, "Base DEF": 556, "ATK%": 18 },
    { "Base HP": 8907, "Base ATK": 183, "Base DEF": 584, "ATK%": 24 },
    { "Base HP": 9570, "Base ATK": 196, "Base DEF": 628, "ATK%": 24 }
  ],
  actvTalents: [
    {
      type: "Normal Attack",
      name: "Turnaround Shooter",
      desc: [],
      stats: [
        {
          name: "1-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 44.73,
          multType: 1
        },
        {
          name: "2-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 42.19,
          multType: 1
        },
        {
          name: "3-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 53.16,
          multType: 1
        },
        {
          name: "4-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 70.62,
          multType: 1
        },
        {
          name: "Aimed Shot",
          dmgTypes: ["CA", "Physical"],
          baseMult: 43.86,
          multType: 1
        },
        {
          name: "Fully-charged Aimed Shot",
          dmgTypes: ["CA", "Elemental"],
          baseMult: 124,
          multType: 8
        },
        ...lightPAs_Bow
      ]
    },
    {
      type: "Elemental Skill",
      name: "Wind Realm of Nasamjnin",
      image: "4/46/Talent_Wind_Realm_of_Nasamjnin",
      desc: [],
      getXtraLv: xtraTlLv.cons3,
      stats: [
        {
          name: "Skill DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 148.8,
          multType: 2
        },
        {
          name: "Pressurized Collapse Vortex DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 108,
          multType: 2
        }
      ]
    },
    {
      type: "Elemental Burst",
      name: "The Wind’s Secret Ways",
      image: "f/fc/Talent_The_Wind%27s_Secret_Ways",
      desc: [],
      getXtraLv: xtraTlLv.cons5,
      stats: [
        {
          name: "Skill DMG",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 377.6,
          multType: 2
        }
      ],
      energyCost: 80
    }
  ],
  pasvTalents: [
    {
      type: "Ascension 1",
      name: "Impetuous Flow",
      image: "7/7f/Talent_Impetuous_Flow",
      desc: (
        <>
          When Faruzan is in the Manifest Gale state created by Wind Realm of
          Nasamjnin, the amount of time taken to charge a shot is decreased by
          60%, and she can apply The Wind’s Secret Ways‘ Perfidious Wind’s Bale
          to opponents who are hit by the vortex created by Pressurized
          Collapse.
        </>
      )
    },
    {
      type: "Ascension 4",
      name: "Lost Wisdom of the Seven Caverns",
      image: "3/35/Talent_Lost_Wisdom_of_the_Seven_Caverns",
      desc: (
        <>
          When characters affected by The Wind’s Secret Ways‘ Prayerful Wind’s
          Gift deal Anemo DMG to opponents, this DMG will be increased based on
          32% of Faruzan’s own ATK. This DMG Bonus will be cleared 0.1s after
          dealing Anemo DMG to opponents, and can be triggered once every 0.8s.
        </>
      )
    },
    {
      type: "Passive",
      name: "Tomes Light the Path",
      image: "2/23/Talent_Tomes_Light_the_Path",
      desc: <></>
    }
  ],
  constellation: [
    {
      name: "Truth by Any Means",
      image: "f/f2/Constellation_Truth_by_Any_Means",
      desc: (
        <>
          Faruzan can fire off a maximum of 2 Hurricane Arrows using fully
          charged Aimed Shots while under a single Wind Realm of Nasamjnin
          effect.
        </>
      )
    },
    {
      name: "Overzealous Intellect",
      image: "5/5b/Constellation_Overzealous_Intellect",
      desc: (
        <>
          The duration of the Dazzling Polyhedron created by The Wind’s Secret
          Ways increased by 6s.
        </>
      )
    },
    {
      name: "Spirit-Orchard Stroll",
      image: "b/b5/Constellation_Spirit-Orchard_Stroll",
      desc: "Wind Realm of Nasamjnin"
    },
    {
      name: "Divine Comprehension",
      image: "8/82/Constellation_Divine_Comprehension",
      desc: (
        <>
          The vortex created by Wind Realm of Nasamjnin will restore Energy to
          Faruzan based on the number of opponents hit: If it hits 1 opponent,
          it will restore 2 Energy for Faruzan. Each additional opponent hit
          will restore 0.5 more Energy for Faruzan.
          <br />A maximum of 4 Energy can be restored to her per vortex.
        </>
      )
    },
    {
      name: "Wonderland of Rumination",
      image: "f/f7/Constellation_Wonderland_of_Rumination",
      desc: "The Wind’s Secret Ways"
    },
    {
      name: "The Wondrous Path of Truth",
      image: "9/9a/Constellation_The_Wondrous_Path_of_Truth",
      desc: (
        <>
          Characters affected by The Wind’s Secret Ways‘ Prayerful Wind’s
          Benefit have 40% bonus CRIT DMG when they deal Anemo DMG. When the
          active character deals DMG while affected by Prayerful Wind's Benefit,
          they will apply Pressurized Collapse to the opponent damaged. This
          effect can be triggered once every 3s. This CD is shared between all
          party members.
        </>
      )
    }
  ],
  buffs: [
    {
      index: 0,
      src: "Prayerful Wind’s Benefit",
      desc: (args) => {
        return (
          <>
            Increases <Green>Anemo DMG Bonus</Green> to all nearby characters by{" "}
            <Green b>{windGiftBnValue(args)}%</Green>.<br />
            At A4, increases <Green>Anemo DMG</Green> based on{" "}
            <Green b>32%</Green> of Faruzan’s <Green>Base ATK</Green>.<br />
            At C6, increases <Green>Anemo CRIT DMG</Green> by{" "}
            <Green b>40%</Green>.
          </>
        );
      },
      isGranted: () => true,
      affect: "party",
      labels: [
        "Elemental Burst Level",
        "Ascension 4",
        "Base ATK (A4)",
        "Constellation 6"
      ],
      inputs: [1, false, 0, false],
      inputTypes: ["text", "check", "text", "check"],
      maxs: [13, 0, 9999],
      addBnes: (obj) => {
        const { ATTRs, tkDesc, tracker } = obj;
        const bnValue = windGiftBnValue(obj);
        addAndTrack(tkDesc, ATTRs, "Anemo DMG Bonus", bnValue, tracker);
      },
      addFinalBnes: ({
        toSelf,
        hitBnes,
        char,
        ATTRs,
        inputs,
        charData,
        infusion,
        tkDesc,
        tracker
      }) => {
        if (toSelf ? checkAscs[4](char) : inputs?.[1]) {
          const ATK = toSelf ? ATTRs["Base ATK"] : inputs[2] || 0;
          const tlMult = 32;
          const settings = {
            vision: charData.vision,
            infusion,
            elmt: "Anemo",
            type: "flat",
            value: applyPct(ATK, tlMult)
          };
          const desc = ` / ${round2(tlMult)}% of ${ATK} Base ATK`;
          incElementalBnes(settings, hitBnes, tkDesc + desc, tracker);
        }
        if (toSelf ? checkCons[6](char) : inputs?.[3]) {
          const settings = {
            vision: charData.vision,
            infusion,
            elmt: "Anemo",
            type: "cDmg",
            value: 40
          };
          incElementalBnes(settings, hitBnes, tkDesc, tracker);
        }
      }
    }
  ],
  debuffs: [
    {
      index: 0,
      src: "Perfidious Wind’s Bale",
      desc: () => (
        <>
          Decreases opponents' <Green>Anemo RES</Green> by <Green b>30%</Green>.
        </>
      ),
      isGranted: () => true,
      addPntes: simpleAnTmaker("rdMult", "Anemo_rd", 30)
    }
  ]
};

export default Faruzan;
